import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import React, { useEffect, useReducer, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import wx from "weixin-js-sdk";
import { saveJournal } from "../commonFetch";
import ToBack from "../components/ToBack";
import reducer from "../reducer";

const reject = async (candidateID, jobID) => {
  const response = await fetch(
    `/gin-api/complex/candidate-reject-sendin?candidateID=${candidateID}&jobID=${jobID}`,
    {
      method: "DELETE",
    },
  );
  return response;
};

/**
 * 岗位
 */
export default function Details() {
  const [state, dispatch] = useReducer(reducer, {
    PROGRESS: 0,
    RATE: 0,
    resume: { id: "" },
    sendin: "",
    sendinList: [],
  });
  const [auth, setAuth] = useState(() => {
    const raw = localStorage.getItem("auth");
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        return { ...parsed, isVirtual: false };
      } catch (e) {
        return null;
      }
    }
    const virtual = localStorage.getItem("virtual_id");
    if (virtual) {
      const cleaned = virtual.replace(/-/g, "");
      if (cleaned !== virtual) localStorage.setItem("virtual_id", cleaned);
      return { id: cleaned, uuid: cleaned, isVirtual: true };
    }
    return null;
  });
  const [employer, setEmployer] = useState({ id: "" });
  const [employerUser, setEmployerUser] = useState({ id: "" });
  const fairId = new URLSearchParams(useLocation().search).get("fairId");
  const [favorite_id, setFavoriteId] = useState(0);
  const { id } = useParams();
  const [job, setJob] = useState({ id: "" });
  const { search } = useLocation();
  const uuid = new URLSearchParams(useLocation().search).get("u_id"); //eslint-disable-line
  const [rejectable, setRejectable] = useState(false);
  const [fromScan, setFromScan] = useState(""); // 标记扫码来源
  const [loadingResume, setLoadingResume] = useState(true); // 简历加载状态

  React.useEffect(() => {
    if (fromScan) {
      // 延时2秒 发送请求
      setTimeout(() => {
        if (!auth || !id) return;
        const saveFairJournal = async () => {
          const response = await fetch("/gin-api/fair/_/journal", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              relation_id: auth.id.toString(),
              reference_id: fairId,
              action: "浏览岗位",
              job_id: id,
              fromScan: fromScan,
            }),
          });
          if (!response.ok) {
            console.info("failed to save fair journal");
          }
        };
        saveFairJournal();
      }, 2000);
    }
  }, [fromScan]);

  const handleReject = () => {
    if (confirm("确定要撤销投递吗？")) {
      const response = reject(auth.id, id);
      if (response.status >= 400) {
        alert("撤销失败，请稍后重试");
        return;
      }
      alert("操作已提交至服务器");
      // 重置投递状态
      dispatch({ type: "set", payload: { key: "sendin", value: "" } });
      dispatch({ type: "set", payload: { key: "sendinList", value: [] } });
      setRejectable(false);
    }
  };

  useEffect(() => {
    if (id && uuid) {
      fetch(`/gin-api/job/${uuid}/${id}`)
        .then((response) => {
          if (response.status < 400) return response.json();
          throw new Error("请求数据失败");
        })
        .then((data) => {
          setJob(data);
          dispatch({
            type: "set",
            payload: { key: "PROGRESS", value: 1 },
          });
        })
        .catch((err) => window.console.error(err));
    }
  }, [id, uuid]);

  useEffect(() => {
    if (1 === state.PROGRESS) {
      fetch(`/api/simple/biz/employer/${job.employerId}/${job.employerUuid}`)
        .then((response) => {
          if (response.status < 400) return response.json();
          throw new Error("请求数据失败");
        })
        .then((data) => {
          setEmployer(data);
          dispatch({
            type: "set",
            payload: { key: "PROGRESS", value: 2 },
          });
        })
        .catch((err) => window.console.error(err));
    } else if (2 === state.PROGRESS) {
      const url = [
        "/api/simple/biz/employer-user",
        "?option=filterBy-refId",
        `&refId=${employer.id}`,
      ];
      fetch(url.join(""))
        .then((response) => {
          if (response.status < 400) return response.json();
          throw new Error("请求数据失败");
        })
        .then((data) => {
          setEmployerUser(data);
        })
        .catch((err) => window.console.error(err));
    }
  }, [state.PROGRESS]);

  useEffect(() => {
    const raw = localStorage.getItem("auth");
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        setAuth({ ...parsed, isVirtual: false });
      } catch (e) {
        // ignore
      }
    }
    const getParamFromUrl = (key) => {
      // 优先检查标准的 search
      const searchParams = new URLSearchParams(window.location.search);
      const val = searchParams.get(key);
      if (val) return val;
      // 检查 hash 中是否含有 query 且带有 ?
      const hash = window.location.hash || "";
      const qIdx = hash.indexOf("?");
      if (qIdx >= 0) {
        const hashQuery = hash.substring(qIdx + 1);
        const hashParams = new URLSearchParams(hashQuery);
        const hv = hashParams.get(key);
        if (hv) return hv;
      }
      return null;
    };

    const fromScanParam = getParamFromUrl("fromScan");
    const sceneParam = getParamFromUrl("scene");
    if (fromScanParam || sceneParam) {
      setFromScan(fromScanParam || sceneParam);
    }

    if (fairId > 0) {
      saveJournal({
        ref_id: auth?.id || 0,
        ref_id2: id,
        fairId: fairId,
        category: "参加招聘会并浏览岗位",
        tag: "个人用户",
        ref_uuid: auth?.uuid || "",
        ref_uuid2: uuid,
      });
    } else {
      saveJournal({
        ref_id: auth?.id || 0,
        ref_uuid: auth?.uuid || "",
        fairId: "0",
        ref_id2: id,
        ref_uuid2: uuid,
        category: "浏览岗位",
        tag: "个人用户",
      });
    }
    if (auth && auth.id) {
      const url = [
        "/api/miscellaneous/favorite",
        "?option=by-ref_id-ref_id2-category-tag",
        `&ref_id=${auth.id}`,
        `&ref_id2=${id}`,
        "&category=岗位",
        "&tag=个人用户",
      ];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          if (data.length > 0) setFavoriteId(data[0].id);
        });
    }
  }, []);

  useEffect(() => {
    setLoadingResume(true);
    if (auth) {
      // 添加auth存在检查
      fetch("/gin-api/resume?option=filterBy-refId&refId=" + auth.id)
        .then((response) => response.status < 400 && response.json())
        .then((data) => {
          dispatch({ type: "set", payload: { key: "resume", value: data } });
        })
        .finally(() => {
          setLoadingResume(false);
        });
    } else {
      setLoadingResume(false);
    }
  }, [id]);

  useEffect(() => {
    if (state["resume"]?.id) {
      const url = [
        "/gin-api/sendin",
        "?option=filterBy-refId-ref1Id-timeRange",
        `&refId=${state["resume"]?.id}`,
        `&ref1Id=${id}`,
        `&timeBegin=${dayjs().format("YYYY-MM-DD")}`,
        `&timeEnd=${dayjs().add(1, "day").format("YYYY-MM-DD")}`,
      ];
      fetch(url.join(""))
        .then((response) => response.status < 400 && response.json())
        .then((data) => {
          if (data.length > 0) {
            if (dayjs().diff(dayjs(data[data.length - 1].publishTime), "hour") <= 24) {
              setRejectable(true);
            }
            // 设置 sendin 状态为最新的一条记录，表示已投递
            dispatch({ type: "set", payload: { key: "sendin", value: data[data.length - 1] } });
          }
          dispatch({ type: "set", payload: { key: "sendinList", value: data } });
        });
    }
  }, [state["resume"]]);

  const handleFavorite = () => {
    if (auth === null) {
      location.href = "#登录";
    } else if (favorite_id) {
      fetch(`/api/miscellaneous/favorite/${favorite_id}`, {
        method: "DELETE",
      }).then((response) => {
        if (response.status === 200) setFavoriteId(0);
      });
    } else {
      fetch("/api/miscellaneous/favorite", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          ref_id: auth.id,
          ref_id2: id,
          category: "岗位",
          tag: "个人用户",
          ref_uuid: auth.uuid,
          ref_uuid2: uuid,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.insertId > 0) setFavoriteId(data.insertId);
        });
    }
  };

  const handleResumeDelivery = () => {
    if (auth["id"] !== 0) {
      if (state["resume"]) {
        if (!state["resume"]?.phone || state["resume"].phone === "") {
          alert("请您检查个人信息中手机号码是否完善");
          location.href = "#/我的/简历";
          return;
        }
        if (!state["resume"]?.email || state["resume"].email === "") {
          alert("请您检查个人信息中电子邮箱是否完善");
          location.href = "#/我的/简历";
          return;
        }
        if (!state["resume"]?.name || state["resume"].name === "") {
          alert("请您检查个人信息中姓名是否完善");
          location.href = "#/我的/简历";
          return;
        }
        if (!state["resume"]?.gender || state["resume"].gender === "") {
          alert("请您检查个人信息中性别是否完善");
          location.href = "#/我的/简历";
          return;
        }
        if (!state["resume"]?.birthday || state["resume"].birthday === "") {
          alert("请您检查个人信息中出生年月是否完善");
          location.href = "#/我的/简历";
          return;
        }
        if (!state["resume"]?.address1 || state["resume"].address1 === "") {
          alert("请您检查个人信息中现居住地址中省份是否完善");
          location.href = "#/我的/简历";
          return;
        }
        if (!state["resume"]?.address2 || state["resume"].address2 === "") {
          alert("请您检查个人信息中现居住地址中城市是否完善");
          location.href = "#/我的/简历";
          return;
        }
        if (!state["resume"]?.address3 || state["resume"].address3 === "") {
          alert("请您检查个人信息中现居住地址地区是否完善");
          location.href = "#/我的/简历";
          return;
        }
        // fetch(`/api/delivery/?uuid=${auth.uuid}`, {
        //     method: 'POST',
        //     headers: { 'content-type': 'application/json' },
        //     body: JSON.stringify({
        //         common_user_id: auth.id,
        //         recruitment_id: id,
        //         recruitment_uuid: uuid,
        //         datime: dayjs().format('YYYY-MM-DD HH:mm'),
        //     }),
        // })
        const sendResume = fetch(
          `/gin-api/complex/candidate-sendin-resume?candidateID=${auth.id}&jobID=${id}&jobUUID=${uuid}`,
          {
            method: "POST",
            headers: { "content-type": "application/json" },
          },
        );

        if (fairId > 0 && fromScan) {
          fetch("/gin-api/fair/_/journal", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              relation_id: auth.id.toString(),
              reference_id: fairId,
              action: "投递简历",
              job_id: id,
              fromScan: fromScan,
            }),
          });
        }

        sendResume.then((response) => {
          if (response.status >= 400) {
            alert("投递失败，请稍后重试");
            return;
          }
          if (fairId > 0) {
            saveJournal({
              ref_id: auth.id,
              ref_id2: id,
              fairId: fairId,
              category: "参加招聘会并投递简历",
              tag: "个人用户",
              ref_uuid: auth.uuid,
              ref_uuid2: uuid,
            });
          } else {
            saveJournal({
              ref_id: auth.id,
              ref_id2: id,
              fairId: 0,
              category: "投递简历",
              tag: "个人用户",
              ref_uuid: auth.uuid,
              ref_uuid2: uuid,
            });
          }
          location.reload(true);
        });
      } else {
        alert("请先填写简历");
        location.href = "#/我的/简历";
      }
    } else {
      location.href = `#/登录?id=${id}`;
    }
  };

  const getButton = () => {
    let button;
    if (loadingResume) {
      button = (
        <button type="button" className="btn btn-secondary nav-btn w-100 h-100" disabled>
          加载中
        </button>
      );
    } else if (!auth || auth.id === 0 || auth.isVirtual) {
      button = (
        <button type="button" className="btn btn-secondary nav-btn w-100 h-100" disabled>
          请先登录
        </button>
      );
    } else if (!state["resume"] || state["resume"].id === "") {
      button = (
        <button type="button" className="btn btn-secondary nav-btn w-100 h-100" disabled>
          请先完善简历
        </button>
      );
    } else if (state["sendin"]) {
      button = (
        <button type="button" className="btn btn-secondary nav-btn w-100 h-100" disabled>
          已投递
        </button>
      );
    } else {
      button = (
        <button
          type="button"
          className="btn btn-primary nav-btn w-100 h-100"
          onClick={handleResumeDelivery}
        >
          投递简历
        </button>
      );
    }
    return button;
  };

  const consulting = () => {
    window.location.href = `#消息/${employer.name}/${employerUser.id}`;
  };

  const navigateTo = () => {
    const urlParams = new URL(window.location.href);
    const href = urlParams?.hash;
    wx.miniProgram.navigateTo({
      url: `/pages/canvas/canvas?href=${href}`,
    });
  };

  return (
    <>
      <div className="container-fluid" style={{ fontSize: 14 }}>
        <div className="card border-0 shadow mt-2 ">
          <ToBack report advisory dataType="岗位" dataId={id} search={search} />
          <div className="card-body">
            {job.name && (
              <>
                <div className="row mt-3">
                  <div className="col">
                    <h4>{job.name}</h4>
                  </div>
                  <div className="col-4">
                    <span className="pull-right text-muted" style={{ fontSize: 14 }}>
                      {dayjs(job.refreshTime).format("YYYY-MM-DD")}
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <span className="text-muted" style={{ fontSize: 14 }}>
                      {job.addressLevel2 ? job.addressLevel2 : job.addressLevel1} |{job.education}|
                      {job.category}
                    </span>
                  </div>
                </div>
                <div className="row ">
                  <div className="col">
                    <h5 className="text-success">
                      {job.salary1 !== "0" && job.salary2 !== "0"
                        ? `${job.salary1}-${job.salary2}/月`
                        : "面议"}
                    </h5>
                  </div>
                </div>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
                <div className="row mt-3">
                  <div className="col">
                    <a
                      className="pull-left"
                      href={`#岗位/企业/${job.employerId}?u_id=${job.employerUuid}&fairId=${fairId}`}
                    >
                      <h6>{employer.name}</h6>
                    </a>
                    <div className="pull-right">
                      {2 <= state.PROGRESS && (
                        <button
                          className="text-success btn btn-link p-0"
                          style={{ fontSize: "14px", border: "none" }}
                          onClick={consulting}
                        >
                          咨询
                        </button>
                      )}
                      &nbsp;&nbsp;
                      <button
                        onClick={navigateTo}
                        className="text-success btn btn-link p-0"
                        style={{ fontSize: "14px", border: "none" }}
                      >
                        生成海报
                      </button>
                    </div>
                  </div>
                </div>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
                <div className="row mt-3">
                  <div className="col">
                    <h5>职位描述</h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    岗位要求:
                    <br />
                    <div dangerouslySetInnerHTML={{ __html: job.requirement }} />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    工作内容:
                    <br />
                    <div dangerouslySetInnerHTML={{ __html: job.description }} />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="recommond-bottom" />
      <div
        className="nav bg-light nav-light fixed-bottom nav-bottom border-top w-100"
        style={{ display: "flex", flexDirection: "column", width: "100%", height: "50px" }}
      >
        <div className="row text-center nav-row w-100 h-100">
          <div className="col-4 nav-col">
            {rejectable && (
              <button
                type="button"
                className="btn btn-outline-danger nav-btn w-100 h-100"
                onClick={handleReject}
              >
                撤销投递
              </button>
            )}
          </div>
          <div className="col-4 nav-col">
            <button
              type="button"
              className="btn btn-light nav-btn text-muted w-100 h-100"
              onClick={handleFavorite}
              disabled={auth === null || auth.id === 0}
            >
              {favorite_id > 0 ? (
                <FontAwesomeIcon icon={faStar} style={{ color: "#FFFF00" }} fixedWidth />
              ) : (
                <FontAwesomeIcon icon={faStar} fixedWidth />
              )}
              收藏
            </button>
          </div>
          {job.status === "停招" ? (
            <div className="col-4 nav-col">
              <button type="button" className="btn btn-secondary nav-btn w-100 h-100" disabled>
                已停招
              </button>
            </div>
          ) : (
            <div className="col-4 nav-col">{getButton()}</div>
          )}
        </div>
      </div>
    </>
  );
}
